/**
 * Centralized API and WebSocket Configuration
 *
 * Change the active configuration here to switch between environments.
 * This ensures HTTP and WebSocket URLs stay in sync.
 */

// Environment configurations
const ENVIRONMENTS = {
  production: {
    http: "https://compelion.com/api/",
    ws: "wss://compelion.com",
  },
  local: {
    http: "http://127.0.0.1:8000/",
    ws: "ws://127.0.0.1:8000",
  },
  awsDev: {
    http: "http://43.204.64.32:4000/",
    ws: "ws://43.204.64.32:4000",
  },
  loadBalancer: {
    http: "http://compelionloadbalancer-1950178212.eu-north-1.elb.amazonaws.com/",
    ws: "ws://compelionloadbalancer-1950178212.eu-north-1.elb.amazonaws.com",
  },
};

// ⚙️ CHANGE THIS TO SWITCH ENVIRONMENTS
const ACTIVE_ENVIRONMENT = "production"; // Options: 'production', 'local', 'awsDev', 'loadBalancer'

// Get active configuration
const activeConfig = ENVIRONMENTS[ACTIVE_ENVIRONMENT];

if (!activeConfig) {
  console.error(
    `Invalid environment: ${ACTIVE_ENVIRONMENT}. Defaulting to 'local'.`,
  );
}

// Export configuration
export const API_CONFIG = {
  // Base URL for HTTP requests (axios)
  BASE_URL: activeConfig?.http || ENVIRONMENTS.local.http,

  // Base URL for WebSocket connections
  WS_BASE_URL: activeConfig?.ws || ENVIRONMENTS.local.ws,

  // Current environment name
  ENVIRONMENT: ACTIVE_ENVIRONMENT,

  // Helper function to build WebSocket URL
  getWebSocketUrl: (path) => {
    const wsBase = activeConfig?.ws || ENVIRONMENTS.local.ws;
    // Ensure path starts with /
    const cleanPath = path.startsWith("/") ? path : `/${path}`;
    return `${wsBase}${cleanPath}`;
  },

  // Check if running in production
  isProduction: () => ACTIVE_ENVIRONMENT === "production",

  // Check if running locally
  isLocal: () => ACTIVE_ENVIRONMENT === "local",
};

// Log current configuration (useful for debugging)
if (process.env.NODE_ENV === "development") {
  console.log("🔧 API Configuration:", {
    Environment: API_CONFIG.ENVIRONMENT,
    HTTP_URL: API_CONFIG.BASE_URL,
    WS_URL: API_CONFIG.WS_BASE_URL,
  });
}

export default API_CONFIG;
